export default {
  GET: {
    DEPENDENTS_ERROR: {
      severity: 'error' as 'error',
      title: 'Uh oh!',
      subtitle: 'Sorry, there was an issue fetching your dependents. Please try again.'
    }
  },
  UPDATE: {
    PATIENT_SELECT_ERROR: {
      severity: 'error' as 'error',
      title: 'Uh oh!',
      subtitle: 'Sorry, there was an issue selecting a patient. Please try again.'
    }
  }
};
